<template>
    <div class="section-posts2 section-posts-list-view">
        <div class="navigations">
            <div class="navigation-status">
                <div class="btn-radius" :class="{active : statusIsAllSelected}" @click="()=>clickStatusEvent('all')">{{ $t('dash.posts.status.all') }}</div>
                <div class="btn-radius" :class="{active : !statusIsAllSelected && filter.statusDisplay.draft}" @click="()=>clickStatusEvent('draft')">{{ $t('dash.post.draft') }}</div>
                <div class="btn-radius" :class="{active : !statusIsAllSelected && filter.statusDisplay.scheduled}" @click="()=>clickStatusEvent('scheduled')">{{ $t('dash.post.scheduled') }}</div>
                <div class="btn-radius" :class="{active : !statusIsAllSelected && filter.statusDisplay.posted}" @click="()=>clickStatusEvent('posted')">{{ $t('dash.post.posted') }}</div>
                <div v-if="statusHideSelected.length" @click.stop="filterIsOpen = true" class="btn-radius active count-other-status-selected"><i class="fa-solid fa-plus"></i>{{ statusHideSelected.length }}</div>
                <div class="btn-radius icon" @click.stop="filterIsOpen = true"><i class="fa-solid fa-plus"></i></div>
            </div>
            <div class="navigation-filter">
                <div class="btn-radius search-bar">
                    <div class="svg"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M17.0625 8.53125C17.0625 10.4139 16.4514 12.1529 15.4219 13.5639L20.6145 18.7605C21.1271 19.2732 21.1271 20.1059 20.6145 20.6186C20.1018 21.1312 19.2691 21.1312 18.7564 20.6186L13.5639 15.4219C12.1529 16.4555 10.4139 17.0625 8.53125 17.0625C3.81855 17.0625 0 13.2439 0 8.53125C0 3.81855 3.81855 0 8.53125 0C13.2439 0 17.0625 3.81855 17.0625 8.53125ZM8.53125 14.4375C9.30687 14.4375 10.0749 14.2847 10.7915 13.9879C11.5081 13.6911 12.1592 13.256 12.7076 12.7076C13.256 12.1592 13.6911 11.5081 13.9879 10.7915C14.2847 10.0749 14.4375 9.30687 14.4375 8.53125C14.4375 7.75563 14.2847 6.9876 13.9879 6.27103C13.6911 5.55445 13.256 4.90335 12.7076 4.3549C12.1592 3.80645 11.5081 3.3714 10.7915 3.07459C10.0749 2.77777 9.30687 2.625 8.53125 2.625C7.75563 2.625 6.98761 2.77777 6.27103 3.07459C5.55445 3.3714 4.90335 3.80645 4.3549 4.3549C3.80645 4.90335 3.3714 5.55445 3.07459 6.27103C2.77777 6.9876 2.625 7.75563 2.625 8.53125C2.625 9.30687 2.77777 10.0749 3.07459 10.7915C3.3714 11.5081 3.80645 12.1592 4.3549 12.7076C4.90335 13.256 5.55445 13.6911 6.27103 13.9879C6.98761 14.2847 7.75563 14.4375 8.53125 14.4375Z" fill="#E3D2EE"></path></svg></div>
                    <input :placeholder="$t('dash.posts.list.search')" v-model.lazy="filter.search">
                </div>
                <div class="btn-radius" :data-count="filterCount" @click.stop="filterIsOpen = true">
                    {{ $t('dash.posts.list.filter') }}
                    <FilterNavigation v-if="filterIsOpen" @close="onFilterClose" @updateCalendar="fetchPost" :filter.sync="filter" :hideSearchBar="true" :showDateRange="true" :pageIds="pagesSelected.map(p => p.id)"/>
                </div>
                <div class="btn-radius icon" @click="fetchPost"><i class="fa-solid fa-rotate-right"></i></div>
            </div>
            <MainNavigation v-on="$listeners" :tabSelected="tabSelected"/>
        </div>
        <div class="loading-overlay fixed" v-if="isLoading || isLoadingMore"><i class="fa-sharp fa-solid fa-spinner-third"></i>{{ $t('dash.posts.list.loading') }}</div>

        <div class="list-posts">
            <div v-for="event in eventsFilter" :key="event.id" :class="event.status" @click="()=>handleEventClick(event.id)" class="item-post carousel card-status-background-color card-status-border-color card-status-border-style-default hover-card-status-background-color">
                <div class="container-badge-status">
                    <div class="badge-status" :status="event.status">{{ $t(`dash.post.${event.status}`) }}</div>
                </div>
                <div class="post-content">
                    <div v-if="event.image" class="post-image" :class="event.type">
                        <img :src="event.image"/>
                        <div class="type-post" :class="event.type"></div>
                    </div>
                    <div class="container-info-text">
                        <div class="container-date">
                            <p class="date">{{ event.formatedDate }}</p>
                        </div>
                        <p class="content">
                            {{ event.content }}
                        </p>
                    </div>
                </div>
                <div class="pages">
                    <Tooltip :text="getPage(event.page.id).name">
                        <Avatar :urlPicture="event.page.avatar" :typeNetwork="event.page.network" :key="event.page.id"></Avatar>
                    </Tooltip>
                </div>
            </div>
            <div ref="sentinel" class="sentinel"></div>
        </div>

        <DrawerPost
            v-if="eventIdSelected && events[eventIdSelected]"
            :event="events[eventIdSelected]"
            @close="closeDrawer"
            @deletePost="handlerDeletePost"
        />
    </div>
</template>


<script>
    import Store from '@/store'
    import MainNavigation from './components/MainNavigation.vue'
    import Avatar from '@/components/dash/utils/avatar.vue'
    import postMixins from '@/components/mixins/Posts.vue'
    import draftMixins from '@/components/mixins/Drafts.vue'
    import sectionPostMixins from './mixins/main.js'
    import FilterNavigation from './components/Filter.vue'
    import DrawerPost from './components/drawer/index.vue'
    import { convertOldDraft, patchDraft } from './utils/draft.js';
    import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'

    export default {
        components: {
            MainNavigation,
            Avatar,
            FilterNavigation,
            DrawerPost,
            Tooltip
        },

        mixins: [postMixins,draftMixins,  sectionPostMixins],

        props: {
            tabSelected: String
        },
        data() {
            return {
                isLoading: true,
                isLoadingMore: false,
                events : {},
                nextCursor: null,
                hasMore: false,

                emptyLoadCount: 0,
                filterIsOpen: false,
                lastFetchedFilter: null,
                filter: {
                    search: '',
                    dateRange: { startDate: null, endDate: null },
                    statusDisplay:  {
                        all: true,
                        scheduled: true,
                        posted: true,
                        draft: true,
                        pending: true,
                        failed: true,
                        removed: false,
                        standby: true,
                        awaiting_approval: true,
                        to_validate: true,
                    },
                    typesDisplay:  {
                        carousel: true,
                        document: true,
                        reel: true,
                        video: true,
                        image: true,
                        story: true,
                    },
                    creators: [],
                    labels: [],
                },
                eventIdSelected:null
            }
        },
        mounted () {
            if (localStorage.getItem("filterList")) {
                const saved = JSON.parse(localStorage.getItem("filterList"))
                // Merge: les defaults garantissent que les nouveaux statuts ont toujours une valeur
                this.filter = {
                    ...this.filter,
                    ...saved,
                    statusDisplay: { ...this.filter.statusDisplay, ...saved.statusDisplay },
                    typesDisplay: { ...this.filter.typesDisplay, ...saved.typesDisplay },
                    creators: Array.isArray(saved.creators) ? saved.creators : [],
                    labels: Array.isArray(saved.labels) ? saved.labels : []
                }
            }

            this._checkScroll = () => {
                if (!this.hasMore || this.isLoadingMore || !this.$refs.sentinel) return
                const rect = this.$refs.sentinel.getBoundingClientRect()
                if (rect.top < window.innerHeight + 800) this.loadMore()
            }

            // capture:true intercepts scroll on any element, not just window
            document.addEventListener('scroll', this._checkScroll, { passive: true, capture: true })

            this.fetchPost()
        },

        methods: {
            buildFilterParams() {
                const allStatusOn = Object.values(this.filter.statusDisplay).every(v => v)
                const statuses = allStatusOn
                    ? null
                    : Object.entries(this.filter.statusDisplay).filter(([k, v]) => v && k !== 'all').map(([k]) => k).join(',') || null
                const allTypesOn = Object.values(this.filter.typesDisplay).every(v => v)
                const types = allTypesOn
                    ? null
                    : Object.entries(this.filter.typesDisplay).filter(([, v]) => v).map(([k]) => k).join(',') || null
                const search = this.filter.search ? this.filter.search.trim() : null
                const startDate = (this.filter.dateRange && this.filter.dateRange.startDate) || null
                const endDate = (this.filter.dateRange && this.filter.dateRange.endDate) || null
                const creator = (this.filter.creators && this.filter.creators.length) ? this.filter.creators.join(',') : null
                const labels = (this.filter.labels && this.filter.labels.length) ? this.filter.labels.join(',') : null
                return { statuses, types, search, startDate, endDate, creator, labels }
            },

            async fetchPost(){

                this.isLoading = true
                this.nextCursor = null
                this.hasMore = false
                this.emptyLoadCount = 0
                const { statuses, types, search, startDate, endDate, creator, labels } = this.buildFilterParams()
                this.lastFetchedFilter = JSON.stringify({ statuses, types, search, startDate, endDate, creator, labels })
                const {body} = await this.postsByPagesV2(
                    this.pagesSelected.map(p=>p.id).join(','),
                    { statuses, types, search, startDate, endDate, creator, labels }
                )
                this.nextCursor = (body && body.nextCursor) || null
                this.hasMore = !!(body && body.hasMore)
                this.events = {}
                const events = {}
                // Tri pour que les stories soient traitées en fin de boucle,
                // évitant qu'elles écrasent l'entrée post principal dans l'objet events
                const posts = (body && body.posts) || []
                posts.sort((a, b) => {
                    const aHasStory = a.page && a.page[0] && (a.page[0].story || a.page[0].story_multiple)
                    const bHasStory = b.page && b.page[0] && (b.page[0].story || b.page[0].story_multiple)
                    return (aHasStory ? 1 : 0) - (bHasStory ? 1 : 0)
                })
                for (const post of posts) {
                    if (!post.draft) post.draft = { data: {} }
                    const event = await this.buildEvent(post);

                    if (event) {
                       
                        console.log('event', event)
                        
                        if (!this.$store.getters['planner/staticEvents'][event.id]) {
                        
                            let storification = null
                            let storificationDate = null

                            //storification planifier ?
                            if (event.originalPost && event.originalPost.page && event.originalPost.page.length && event.originalPost.page[0].storification && event.originalPost.page[0].story) {

                                storification = true

                                //si storification et que le post est deja poster alors detecter si la storification est en cours de posting 
                                if (
                                    event.originalStatus == 'scheduled' && 
                                    events[event.id] && 
                                    events[event.id].originalStatus == 'posted' && 
                                    new Date(event.date).getTime() - new Date(events[event.id].date).getTime() <= 300000 // si storification prevu dans les 5min (300000ms) alors pennding
                                ) {
                                    event.status = 'pending'
                                }
                            }
                            
                            if (!storification) {
                                if (this.$store.getters['planner/patchEvents'][event.id]) {
                                    events[event.id] =  {...event, ...this.$store.getters['planner/patchEvents'][event.id]};
                                }else {
                                    events[event.id] = event;
                                }
                                
                            } 


                            //storifcation into draft?
                            if (!storification && event.page.network == "instagram" && event.originalStatus == "draft") {
                                if (event.draft.saveAllFormData && event.draft.tab !== 'story') {

                                    try {
                                        storification = event.draft.saveAllFormData.pages[event.page.id].formDataNetwork.instagram.storification.active   
                                    } catch (error) {}

                                    try {
                                        storificationDate = event.draft.saveAllFormData.pages[event.page.id].formDataNetwork.instagram.storification.planifiedDate
                                    } catch (error) {
                                        
                                    }
                                    
                                    if (storification !== false) {
                                        try {
                                            storification = event.draft.saveAllFormData.networks["instagram"].formDataNetwork.instagram.storification.active
                                        } catch (error) {}
                                    }

                                        if (!storificationDate) {
                                        try {
                                            storificationDate = event.draft.saveAllFormData.networks["instagram"].formDataNetwork.instagram.storification.planifiedDate
                                        } catch (error) {}
                                    }

                                    if (storification !== false) {
                                        try {
                                            storification = event.draft.saveAllFormData.main.formDataNetwork.instagram.storification.active
                                        } catch (error) {}
                                    }

                                    if (!storificationDate) {
                                        try {
                                            storificationDate = event.draft.saveAllFormData.main.formDataNetwork.instagram.storification.planifiedDate
                                        } catch (error) {}
                                    }

                                    
                                }
                            }

                            if (storification) {
                                console.log('trouvé storification', event)
                                const eventStorification = {...event}
                                eventStorification.id = eventStorification.id + "_storification"
                                eventStorification.type = 'story'
                                eventStorification.content = 'Storification'

                                if (storificationDate && storificationDate.timestamp) {
                                    console.log('trouvé storification date', storificationDate)
                                    eventStorification.date = new Date(storificationDate.timestamp).toISOString()
                                }  

                                if (event.originalStatus == "draft") {
                                    ///recherche de enclosure
                                    let fileId;

                                    const fileIdSearch = function(files) { 
                                        try {
                                            console.log('fileIdSearch')
                                            return files.find((file) => (
                                                ['video','image'].includes(eventStorification.draft.files[file.id].info.type2) && eventStorification.draft.files[file.id].info.type !== 'image/gif'
                                            )).id
                                    
                                        } catch (error) {
                                            return null
                                        }
                                    }
                            
                    
                            
                                    if (eventStorification.draft.saveAllFormData && eventStorification.draft.saveAllFormData.pages && eventStorification.draft.saveAllFormData.pages[eventStorification.page.id] && eventStorification.draft.saveAllFormData.pages[eventStorification.page.id].files) {
                                        fileId = fileIdSearch(event.draft.saveAllFormData.pages[eventStorification.page.id].files)
                                    }else if (eventStorification.draft.saveAllFormData && eventStorification.draft.saveAllFormData.networks && eventStorification.draft.saveAllFormData.networks['instagram'] && eventStorification.draft.saveAllFormData.networks['instagram'].files) {
                                        fileId = fileIdSearch(eventStorification.draft.saveAllFormData.networks['instagram'].files)
                                    }else if(eventStorification.draft.saveAllFormData){
                                        fileId = fileIdSearch(eventStorification.draft.saveAllFormData.main.files)
                                    }

                                    if (fileId && eventStorification.draft.files[fileId]) {
                                        if (eventStorification.draft.files[fileId].info.type2 == 'video') {
                                            eventStorification.image = eventStorification.draft.files[fileId].info.enclosure
                                        }else{
                                            eventStorification.image = eventStorification.draft.files[fileId].url
                                        }
                                    }
                                }
                                
                                events[eventStorification.id] = eventStorification;   
                            }

                            //storifcation facebook into draft ?
                            if (storification && event.page.network == "instagram" && event.originalStatus == "draft") {
                                let storificationFacebook = null
                                try {
                                    storificationFacebook = event.draft.saveAllFormData.pages[event.page.id].formDataNetwork.instagram.storification.shareInFacebook
                                } catch (error) {}
                                
                                if (storificationFacebook !== false) {
                                    try {
                                        storificationFacebook = event.draft.saveAllFormData.networks["instagram"].formDataNetwork.instagram.storification.shareInFacebook
                                    } catch (error) {}
                                }

                                if (storificationFacebook !== false) {
                                    try {
                                        storificationFacebook = event.draft.saveAllFormData.main.formDataNetwork.instagram.storification.shareInFacebook
                                    } catch (error) {}
                                }
                                console.log('trouvé storification facebook', storificationFacebook)
                                if (storificationFacebook) {
                                    const page = this.allPages[event.page.id]
                                    console.log("page",page)
                                    if (page.affected_to) {
                                        const pageFacebook = this.pagesSelected.find(p => p.network_id && p.network_id == page.affected_to)

                                        if (pageFacebook) {
                                            const eventStorification = {...event}
                                            eventStorification.page = {
                                                avatar: page.avatar,
                                                id: event.page.id,
                                                network:"facebook",
                                            }
                                            eventStorification.id = eventStorification.id + "_facebook_storification"
                                            eventStorification.type = 'story'
                                            eventStorification.content = 'Storification'

                                            if (storificationDate && storificationDate.timestamp) {
                                                eventStorification.date = new Date(storificationDate.timestamp).toISOString()
                                            }

                                            events[eventStorification.id] = eventStorification;   
                                        }
                                    }
                                }
                            }
                        
                        }
                    }
                }
                this.events = events
                this.isLoading = false
                this.$nextTick(() => this._checkScroll && this._checkScroll())
            },

            async loadMore() {
                if (!this.hasMore || this.isLoadingMore) return
                this.isLoadingMore = true
                const visibleCountBefore = this.eventsFilter.length
                const { statuses, types, search, startDate, endDate, creator, labels } = this.buildFilterParams()
                const { body } = await this.postsByPagesV2(
                    this.pagesSelected.map(p => p.id).join(','),
                    { statuses, types, search, startDate, endDate, creator, labels, cursor: this.nextCursor }
                )
                this.nextCursor = (body && body.nextCursor) || null
                this.hasMore = !!(body && body.hasMore)

                if (!body || !body.posts || body.posts.length === 0) {
                    this.hasMore = false
                    this.isLoadingMore = false
                    return
                }

                const events = { ...this.events }
                for (const post of body.posts) {
                    post.draft = { data: {} }
                    const event = await this.buildEvent(post)
                    if (event) events[event.id] = event
                }
                this.events = events
                this.$nextTick(() => {
                    this.isLoadingMore = false
                    if (this.eventsFilter.length <= visibleCountBefore) {
                        this.emptyLoadCount++
                        if (this.emptyLoadCount >= 5) this.hasMore = false
                    } else {
                        this.emptyLoadCount = 0
                    }
                    this._checkScroll && this._checkScroll()
                })
            },

            closeDrawer() {
                this.eventIdSelected = null
            },

            onFilterClose() {
                this.filterIsOpen = false
                const { statuses, types, search, startDate, endDate, creator, labels } = this.buildFilterParams()
                if (JSON.stringify({ statuses, types, search, startDate, endDate, creator, labels }) !== this.lastFetchedFilter) {
                    this.fetchPost()
                }
            },

            clickStatusEvent(name){
                if (name == 'all') {
                    for (const [statusName, bool] of Object.entries(this.filter.statusDisplay)) {
                        this.filter.statusDisplay[statusName] = true
                    }
                }else{
                    for (const [statusName, bool] of Object.entries(this.filter.statusDisplay)) {
                        this.filter.statusDisplay[statusName] = false
                    }
                    this.filter.statusDisplay[name] = true
                }
                this.fetchPost()
            },

            getPage(id) {
                return this.$store.getters['selectPage/selectPageAllPages'][id];
            }
            
        },
        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },

            eventsFilter() {
                const searchValue = this.filter.search.toLowerCase()
                return Object.values(this.events)
                    .filter(event => {
                        const matchSearch = !searchValue || (event.content && event.content.toLowerCase().includes(searchValue))
                        return this.filter.statusDisplay[event.status] && matchSearch && (!event.type || this.filter.typesDisplay[event.type])
                    })
                    .sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0))
            },

            filterCount() {
                const dateActive = this.filter.dateRange && (this.filter.dateRange.startDate || this.filter.dateRange.endDate) ? 1 : 0
                const creatorActive = this.filter.creators && this.filter.creators.length ? 1 : 0
                const labelActive = this.filter.labels && this.filter.labels.length ? 1 : 0
                return (this.filter.search ? 1 : 0) + (Object.values(this.filter.statusDisplay).includes(false) ? 1 : 0) + (Object.values(this.filter.typesDisplay).includes(false) ? 1 : 0) + dateActive + creatorActive + labelActive
            },

            statusIsAllSelected() {
                return !Object.values(this.filter.statusDisplay).includes(false)
            },
            statusHideSelected() {
                if (this.statusIsAllSelected) return []
                return Object.keys(this.filter.statusDisplay).filter(s => !['all','draft','scheduled','posted'].includes(s) && this.filter.statusDisplay[s])
            }
           
        },

        watch: {
            pagesSelected() {
                this.fetchPost()
            },
            'filter.search'() {
                this.fetchPost()
            },
        },

        beforeDestroy() {
            localStorage.setItem('filterList',JSON.stringify(this.filter))
            if (this._checkScroll) {
                document.removeEventListener('scroll', this._checkScroll, { capture: true })
            }
        },
        
    }
</script>

<style lang="scss" scoped>
.sentinel {
    height: 1px;
}
</style>